import React, { useState, useRef, useEffect } from 'react';
import './css/style.scss';
import smallLogo from '../../../components/header/images/clirnetSmallLogo.png';
import { Fade } from 'react-reveal';
import { GrClose } from '../../icons';
// import ReactHtmlParser from 'react-html-parser';
import { reactHtmlParser } from '../../../common/common'

import LazyImage from '../../CustomLibraries/LazyImage';
function CtaCardV5({ customClass = '', data = {}, callback }) {
  const { title, logo, description, button_text, consent_statement } = data;
  const [showConsent, setShowConsent] = useState(false);
  // function useOutsideDetector(ref) {
  //   useEffect(() => {
  //     function handleClickOutside(event) {
  //       if (ref.current && !ref.current.contains(event.target)) {

  //       }
  //     }
  //     // Bind the event listener
  //     document.addEventListener('mousedown', handleClickOutside);
  //     return () => {
  //       // Unbind the event listener on clean up
  //       document.removeEventListener('mousedown', handleClickOutside);
  //     };
  //   }, [ref]);
  // }

  // function OutsideDetector(props) {
  //   const wrapperRef = useRef(null);
  //   useOutsideDetector(wrapperRef);

  //   return (
  //     <div ref={wrapperRef} className={props.className}>
  //       {props.children}
  //     </div>
  //   );
  // }

  return (
    <div className={`w-100 ctaCardV5Box rounded d-flex flex-column ${customClass}`}>
      <div className="d-flex justify-content-between align-items-center mb-5 ctaCardTop">
        <div className="ctaCardTopLeft">
          {title && (
            <h2 className="fs-2 text-black fw-semibold text-start mb-2 ctaCardTitle">{title}</h2>
          )}
          <h4 className="fs-5 text-dark fw-medium text-start ctaCardSubTitle">Advertisement</h4>
        </div>
        {logo && (
          <div className="ctaCardLogo">
            <div className="ctaCardLogoIn">
              <LazyImage src={logo} alt="CTA Logo" logo />
            </div>
          </div>
        )}
      </div>

      {description && (
        <p className="fs-4 text-dark fw-normal text-start mb-5">{reactHtmlParser(description)}</p>
      )}
      {button_text && (
        <button
          className="fs-4 bg-primary text-white fw-medium rounded text-center ctaLink"
          onClick={() => setShowConsent(true)}
        >
          {button_text ?? 'click here'}
        </button>
      )}
      {showConsent && (
        <>
          <Fade>
            <div className="ctaCardV5Overlay rounded" onClick={() => setShowConsent(false)}></div>
          </Fade>

          <div className="ctaConsentBox rounded text-center">
            <Fade>
              <p className="fs-5 text-black fw-normal consentText">{consent_statement}</p>
              <button
                className="fs-4 bg-primary text-white fw-medium rounded text-center py-2 ctaLink"
                onClick={callback}
              >
                I agree
              </button>
            </Fade>
          </div>
        </>
      )}
    </div>
  );
}

export default CtaCardV5;
